import { GET_SWATCHES_REQUEST, GET_SWATCHES_SUCCESS } from 'actions/browseSwatchesActions';
import { INIT, LOADING, SUCCESS } from 'utils/asyncStatusHelper';

export default function swatches(
	state = {
		asyncStatus: INIT,
		productSwatchDetails: {}
	},
	action = null
) {
	switch (action.type) {
		case GET_SWATCHES_REQUEST:
			return Object.assign({}, state, { asyncStatus: LOADING });
		case GET_SWATCHES_SUCCESS:
			const swatches = action.data.productSwatchDetails[action.pids[0]];
			let sizeIndex;
			let colorIndex;
			swatches &&
				swatches.attributes.map((attr, i) => {
					attr.type === 'TEXT' && (sizeIndex = i);
					attr.type === 'IMAGE' && (colorIndex = i);
				});
			if (typeof colorIndex !== 'undefined') {
				/**  Constructing swatches Response: For each colored FSN this will group diffrent sizes and its product FSN's.
				 * Ex: attributeIndexes: [1, 4], colorIndex: 0, sizeIndex: 1 on a FSN indicates
				 * For 0th colorIndex from attributeOptions for 1st Color the size will be from the
				 * 1st sizeIndex of attributeOptions and the 4th index value.
				 */
				swatches.attributeOptions[colorIndex] = swatches.attributeOptions[colorIndex].map((color, i) => {
					const productsForColor = [];
					const sizesForColor = {};
					for (const pid in swatches.products) {
						if (swatches.products[pid].attributeIndexes[colorIndex] === i) {
							/** If action pid matches the current pid move it to first item of the array else directly push it.
							 * Reason: For each color there will be different sized FSN's.
							 * On Browsepage when you hover on a particular color swatch we've to pick any of the size swatch(FSN) to show.
							 * So we're picking the first item from the array (Check Grid unit code)
							 * But this will create inconsistency when the default selected size (main FSN) is not the first item.
							 * If we find and move the main FSN (which is shown on browsepage by default) in swatch products array to first index it will avoid the issue.
							 */
							if (action.pids[0] === pid) {
								productsForColor.unshift({ productInfo: swatches.products[pid], pid });
							} else {
								productsForColor.push({ productInfo: swatches.products[pid], pid });
							}
							const size = swatches.products[pid].attributeIndexes[sizeIndex];
							sizesForColor[size] = ''; // Having it as object to not have duplicates
						}
					}
					return Object.assign({}, color, {
						products: productsForColor,
						sizes: Object.keys(sizesForColor).sort((a, b) => a - b)
					});
				});
			}

			return Object.assign(
				{},
				state,
				{ asyncStatus: SUCCESS },
				{
					productSwatchDetails: Object.assign({}, state.productSwatchDetails, {
						[action.pids[0]]: swatches || 'NO_SWATCHES'
					})
				}
			);
		default:
			return state;
	}
}
